<template>

  <div  class="px-4 py-3">
    <div class="relative">
      <input
        v-model="searchInput"
        @keyup.enter="performSearch"
        type="text"
        :placeholder="$t('nav.searchForProducts')"
        class="w-full px-4 py-2 pr-10 border border-gray-300 rounded-full shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400"
      />
      <button
        @click="performSearch"
        class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-indigo-700"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ref} from 'vue'

const searchInput = ref('')
const router = useRouter()


const performSearch = () => {
  if (searchInput.value.trim()) {
    router.push({
      path: '/products',
      query: { q: searchInput.value.trim() },
    })
  }
}


</script>
